import gql from 'graphql-tag';
import { GetAllWellsQuery } from '.';


/*
* WellMergeInput:
*   target_well_id: Int!
*   source_well_id: Int!
*/
const WellMerge = gql`
  mutation WellMerge($input: WellMergeInput!) {
    well_merge(input: $input) {
      id
    }
  }
`;


export const wellMergeApi = async (client, sourceWellId, targetWellId) => {
  const variables = {
    input: {
      source_well_id: sourceWellId,
      target_well_id: targetWellId,
    },
  };

  const options = {
    mutation: WellMerge,
    variables,
  };

  const result = await client.mutate(options);
  const { data } = await client.query({ query: GetAllWellsQuery });
  client.writeQuery({ query: GetAllWellsQuery, data });
  return result;
};
